namespace RioERP.Products {
    export interface ProductCategoryForm {
        ProductId: Serenity.LookupEditor;
        CategoryId: Serenity.LookupEditor;
    }

    export class ProductCategoryForm extends Serenity.PrefixedContext {
        static formKey = 'Products.ProductCategory';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ProductCategoryForm.init)  {
                ProductCategoryForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;

                Q.initFormType(ProductCategoryForm, [
                    'ProductId', w0,
                    'CategoryId', w0
                ]);
            }
        }
    }
}
